<template>
    <div>
        <button @click="open" type="button" :aria-expanded="isExpanded.toString()" aria-controls="" class="filter-select rectangle">
            <slot name="buttonFilterContent"></slot>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 20" width="32" height="20" aria-hidden="true" focusable="false">
                <path fill="currentColor" d="M16 12.318L27.333.796c1.043-1.061 2.735-1.061 3.778 0 1.043 1.061 1.043 2.78 0 3.841L16 20 .888 4.637C-.155 3.576-.155 1.857.888.796c1.043-1.061 2.735-1.061 3.778 0L16 12.318z"></path>
            </svg>
        </button>
    </div>
</template>

<script>
import Vue from 'vue';
import VueLodash from "vue-lodash";
import lodash from "lodash";

Vue.use(VueLodash, {lodash: lodash})

export default {
    props: {
        isExpanded: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        open() {
            this.$emit('click');
        }
    }
};

// export default buttonFilterDropdown;
</script>

